
import RelatedArticle from "./RelatedArticle";

export default {
  components: { RelatedArticle },

  props: { fields: { type: Array, default: () => [] } },
};
